import { css } from '@emotion/css'
import { breakpoint, colors, hexToRgba, mediaQueryHelper, spacing, zIndex } from '@offerzen/pinata'

const TOAST_WIDTH = 800

const styles = {
  wrapper: css({
    maxWidth: TOAST_WIDTH,
    width: '100%',
    position: 'fixed',
    top: spacing.extraLarge,
    left: `calc((100% - ${TOAST_WIDTH}px)/2)`,
    zIndex: zIndex.level8,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      width: `calc(100% - ${spacing.extraLarge * 2}px)`,
      top: 75,
      left: spacing.extraLarge,
    },
  }),
}

export default styles
